module.exports = __webpack_public_path__ + "img/label1.f02a2561.png";